import React from "react";

export default function VrReadyIcon(props: any) {
  const { type, ...rest } = props;
  return type === 1 ? (
    <svg
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
    >
      <g fill="none" fillRule="evenodd">
        <g fill="#231F20">
          <g>
            <g>
              <path
                d="M70 27c0 1.103-.897 2-2 2h-2V17h2c1.103 0 2 .897 2 2v8zm-6-12v19c0 2.206-1.794 4-4 4H12c-2.206 0-4-1.794-4-4V12c0-2.206 1.794-4 4-4h48c2.206 0 4 1.794 4 4v3zM18.6 5.2C21 2 22.065 2 24 2h24c1.935 0 3 0 5.4 3.2l.6.8H18l.6-.8zM6 29H4c-1.103 0-2-.897-2-2v-8c0-1.103.897-2 2-2h2v12zm62-14h-2v-3c0-3.314-2.687-6-6-6h-3.5L55 4c-3-4-4.791-4-7-4H24c-2.209 0-4 0-7 4l-1.5 2H12c-3.313 0-6 2.686-6 6v3H4c-2.209 0-4 1.791-4 4v8c0 2.209 1.791 4 4 4h2v3c0 3.313 2.687 6 6 6h48c3.313 0 6-2.687 6-6v-3h2c2.209 0 4-1.791 4-4v-8c0-2.209-1.791-4-4-4z"
                transform="translate(-1124 -365) translate(1124 365) translate(4 20)"
              />
              <path
                d="M32.27 25.357L30.055 18 27.555 18 30.813 28 33.727 28 36.984 18 34.483 18zM41.847 22.714h-1.715v-2.57h1.715c.628 0 1.143.556 1.143 1.284 0 .73-.515 1.286-1.143 1.286m3.428-1.286c0-1.9-1.53-3.428-3.428-3.428h-4v10h2.285v-3.286h1.085L43.103 28h2.458l-2.13-3.672c1.1-.556 1.844-1.67 1.844-2.9"
                transform="translate(-1124 -365) translate(1124 365) translate(4 20)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ) : (
    <svg
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="80"
      height="80"
      viewBox="0 0 80 80"
    >
      <defs>
        <path id="qi1292arba" d="M0 0L65 0 65 67.729 0 67.729z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <g transform="translate(-1073 -2418) translate(975 2398) translate(56 20) translate(42) translate(8 6)">
                  <mask id="afdvwy80tb" fill="#fff">
                    <use xlinkHref="#qi1292arba" />
                  </mask>
                  <path
                    fill="#231F20"
                    d="M59.323 38.743c-3.528 5.292-2.03 12.55-1.366 15.02L34.828 64.867l-1.934-7.736-.935.187c-4.839.968-9.755.98-9.804.98-2.09 0-2.92-1.97-3.039-2.282-.932-4.05-1.67-8.212-2.245-12.015h2.13c3.312 0 6-2.686 6-6v-6h37.221c-.625 2.413-1.604 4.685-2.899 6.743M39 2c12.56 0 22.89 9.7 23.91 22H25c0-3.314-2.687-6-6-6h-2.624C19.678 8.689 28.571 2 39 2m0-2c-3.547 0-6.924.717-10.004 2.003L29 2l-.018.008c-.28.117-.553.25-.828.377C17.66 7.187 11.176 14.09 8.114 18H6c-3.314 0-6 2.686-6 6v14c0 3.314 2.686 6 6 6h8.853c.595 3.968 1.367 8.347 2.354 12.614.05.15 1.27 3.684 4.948 3.684.195 0 4.56-.011 9.26-.843l2.067 8.275 26.901-12.912-.28-.837c-.028-.084-2.765-8.501.828-14.032l.003.002C63.505 35.92 65 31.136 65 26 65 11.64 53.36 0 39 0"
                    mask="url(#afdvwy80tb)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
